import * as React from 'react';
import { getEntity } from '../data/ReduxRoot';
import { useCacheRecord } from '../data/useCacheRecord';
import { ParallelLoad } from '../data/ParallelLoad';
import { getRowLabel } from 'gossamer-unified';

interface DynamicTextElementProps {
  entityId: string;
  recordKey: string;
}

const DynamicTextElement = (props: DynamicTextElementProps): React.JSX.Element => {
  const entity = getEntity(props.entityId);
  const record = useCacheRecord(entity, props.recordKey);
  const label = getRowLabel(entity, 'Dynamic', record.data);
  return (
    <ParallelLoad responses={[record]}>
      <DynamicText text={label} />
    </ParallelLoad>
  );
};

interface DynamicTextProps {
  text: string;
}

export const DynamicText: React.FC<DynamicTextProps> = (props) => {
  const regex = /<(.+?):(.+?):(.+?)>/g;
  let result: RegExpExecArray | null;
  let lastIndex = 0;
  const out: React.JSX.Element[] = [];
  while ((result = regex.exec(props.text)) !== null) {
    out.push(<span key={result.index}>{props.text.substring(lastIndex, result.index)}</span>);
    lastIndex = result.index + result[1].length + result[2].length + result[3].length + 4;
    if (result.length !== 4 || result[1] !== 'lookup') {
      out.push(<span key="~invalid">invalid dynamic text</span>);
    } else {
      out.push(<DynamicTextElement entityId={result[2]} recordKey={result[3]} key={result[0]} />);
    }
  }
  out.push(<span key={lastIndex}>{props.text.substring(lastIndex)}</span>);
  return <>{out}</>;
};
